// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__aiGOI","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1ODFm"};